export default __webpack_public_path__ + "static/media/raleway-regular-webfont.f6b7e09b.woff2";